import React, {useState} from "react";
import styled from "styled-components";
import TableComponent from "../../common/components/TableComponent";
import {getSignedURL} from "../../managers/awsService";
import EditDialogComponent from "../editDialog";

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
const ComponentHeader = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: max-content;
    justify-content: space-between;
`;
const SearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    font-size: 22px;
    align-items: center;
`;
const AddNewButton = styled.button`
    font-family: MuseoSans, serif;
    font-size: 16px;
    font-weight: 500;
    border-radius: 8px;
    background-color: #832729;
    color: white;
    white-space: nowrap;
    padding: 8px 10px;
    border: none;
    outline: none;
`;
export const ThumbnailImg = styled.img`
    width: 42px;
    height: 42px;
    object-fit: contain;
`;

function ParentCategoriesComponent(props) {
    const {state, refreshList} = props;
    const [selectedCategory, setSelectedCategory] = useState("");
    return (
        <MainContainer>
            <ComponentHeader>
                <SearchContainer>
                    Parent Categories
                </SearchContainer>
                <AddNewButton onClick={props.onAddNewAdvertiserClicked}>
                    Add Category
                </AddNewButton>
            </ComponentHeader>
            <TableComponent.Table cellpadding="0" cellspacing="0">
                <TableComponent.TableHead>
                    <TableComponent.HeadColumn>Category Name</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Added On</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn/>
                </TableComponent.TableHead>
                <TableComponent.TableBody>
                    {state?.categoryList?.map((category) =>

                        <TableComponent.BodyRow
                            key={category._id}
                            onClick={() =>
                                setSelectedCategory(selectedCategory ? "" : category._id)
                            }
                        >
                            {/*<TableComponent.BodyColumn>*/}
                            {/*    <ThumbnailImg src={getSignedURL(category.media)}/>*/}
                            {/*</TableComponent.BodyColumn>*/}
                            <TableComponent.BodyColumn>
                                {category.name}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {new Date(category.addedOn).toDateString()}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                <EditDialogComponent entityName="parent-category" data={category}
                                                     refreshList={refreshList}/>
                            </TableComponent.BodyColumn>
                        </TableComponent.BodyRow>
                    )}
                </TableComponent.TableBody>
            </TableComponent.Table>
        </MainContainer>
    );
}

export default ParentCategoriesComponent;
